import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {filter, first, switchMap} from "rxjs/operators";
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {HostingLogsComponent} from "./hosting-logs.component";
import {HostingService} from "../hosting.service";

@Injectable()
export class HostingLogsResolver implements Resolve<HostingLogsComponent|null> {

  constructor(
    private _hostingService: HostingService,
  private _store: Store<fromStore.DbStoreState>,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;
      this._store.select(fromStore.getLogsLoaded(websiteId))
        .pipe(
          filter((loaded: boolean): boolean => loaded),
          switchMap(() => this._store.select(fromStore.getLogsMap(websiteId))),
          first()
        )
        .subscribe((logMap: any) => {
          const log: any = logMap[websiteId];
          if (log) {
            resolve(log);
          }
          else {
            resolve(null);
          }
        });

    });



  }

}
